var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUploadTooltipIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Zm1.173 10.278c-.398.561-.796.946-1.224 1.16-.31.152-.652.225-.997.214-.904-.075-1.324-.756-.93-1.84l1.19-3.267c.256-.705.007-.92-.196-.925-.243-.004-.532.223-.869.681a.18.18 0 0 1-.293-.207c.398-.561.796-.946 1.224-1.16.31-.152.652-.225.997-.214.904.075 1.325.756.93 1.84L6.816 9.827c-.256.705-.008.92.196.925.242.004.531-.223.868-.681a.18.18 0 0 1 .293.207Zm.954-6.799a.845.845 0 1 1-1.59-.578.845.845 0 0 1 1.59.578Z",
  fill: "#FFBFBF",
  fillOpacity: 0.9
})));
export { SvgUploadTooltipIcon as ReactComponent };
export default __webpack_public_path__ + "9b96eff9b021df932215d0dec5bbc1e7.svg";